import classNames from 'classnames/bind';
import React, { useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';
import Select from '@/components/ui/kit/Select';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const [setting, setSetting] = useState();
  const domRefs = useRef({
    relay: useRef(),
  }).current;

  useEffect(() => {
    domRefs.relay.current.value = command.data.relay;
    setSetting(command.data.setting);
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = Math.max(0, Math.trunc(e.target.value));
    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Relay Instance Number">
        <FieldNumber ref={domRefs.relay} name="relay" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Setting">
        <Select name="setting" value={setting} onChange={handleBlur} className={cx('select')}>
          <option value={1}>On</option>
          <option value={0}>Off</option>
        </Select>
      </FieldRow>
    </div>
  );
};

export default Command;
